import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { api } from '../../api';
import { t } from '../../i18n';

/** Student portal — dance levels, shown as cards with a level badge. */
@customElement('cadence-portal-levels')
export class CadencePortalLevels extends LitElement {
  @state() private levels: any[] = [];
  @state() private loading = true;

  static styles = css`
    :host { display: block; }
    h1 { margin: 0 0 var(--space-4); font-size: 1.6rem; }
    .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: var(--space-4); }
    .level-card { border: 1px solid var(--color-border); border-radius: var(--radius-lg); padding: var(--space-5); background: var(--color-bg-primary); display: flex; flex-direction: column; gap: 10px; }
    .level-card .type { font-weight: 700; font-size: 1.05rem; }
    .bar { height: 8px; border-radius: 999px; background: var(--color-border); overflow: hidden; }
    .bar > span { display: block; height: 100%; background: var(--color-primary); }
  `;

  connectedCallback(): void { super.connectedCallback(); this.load(); }
  private async load() {
    this.loading = true;
    try { this.levels = await api.get<any[]>('/portal/levels'); }
    finally { this.loading = false; }
  }

  render() {
    if (this.loading) return html`<cadence-loading></cadence-loading>`;
    return html`
      <h1>${t('common.portalNav.levels')}</h1>
      ${this.levels.length
        ? html`<div class="grid">${this.levels.map((l) => html`
            <div class="level-card">
              <cadence-badge variant="soft">${l.level_name}</cadence-badge>
              <span class="type">${l.dance_type_name}</span>
              <div class="bar"><span style="width:${Math.min(100, ((l.level_sort ?? 1) / 4) * 100)}%"></span></div>
            </div>`)}</div>`
        : html`<cadence-empty-state heading=${t('common.portal.noLevels')}></cadence-empty-state>`}
    `;
  }
}
